module.exports = __webpack_public_path__ + "static/mary-cervasio-64a7d89257609ef903fd6ad9a7efd07b.png";